import { getStyle } from "../../../../../hooks/use-styles";


const DistanceBadge = ({ distance }) => {
  const distanceInKM = (distance / 1000).toFixed(1);

  return (
    <div className="product-distance-badge">
      <div className="flex align-center">
        <img
          src="/assets/icons/location-pin-purple.svg"
          alt="locationMarker"
        />
        <div
          className="font-12-normal-400-lh-20"
          style={{ color: getStyle("primaryColor") }}
        >
          {`${distanceInKM.toString().replace(".0","")} KM`}
        </div>
      </div>
    </div>
  );
};

export default DistanceBadge;
